var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jz-tooltip",class:[
    _vm.$data.staticClass,
    _vm.$data.class,
    ("tooltip-" + _vm.direction),
    { 'tooltip-visible': _vm.open }
  ]},[_vm._t("default"),_c('div',{staticClass:"tooltip-content"},[_vm._t("tooltip")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }